import React, { useState, useRef, useEffect } from 'react';
import '../../CustomModule.css';
import { getControlStyle } from '../../../../../Components/helper';
import HTMLCKeditor from '../../../../../Components/CommonCustomLibrary/HTMLCKeditor';
import { ActiveIcon, DeleteIcon, DuplicateIcon, EditIcon } from '../../../../../bombiix-icon';

export function HTMLControl({
  label,
  fromForm,
  duplicatingItem,
  editingInput,
  gridIndex,
  pageIndex,
  showDelete,
  deleteItem,
  supplierVisible,
  handleSupplierPermission,
  otherConfiguration,
  onChange,
  ckeditorData,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
  onHeightChange,
  gridW,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editorData, setEditorData] = useState(ckeditorData || '');
  const htmlRef = useRef(null);
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };
  const handleCkeditor = (data) => {
    setEditorData(data);
  };
  const handleAddData = () => {
    onChange(editorData, label, gridIndex, pageIndex);
    setIsModalOpen(false);
  };
  const combinedStyles = getControlStyle(otherConfiguration);
  const adjustHTMLHeight = () => {
    if (htmlRef.current) {
      htmlRef.current.style.height = 'auto'; // Reset height to auto
      htmlRef.current.style.height = `${htmlRef.current.scrollHeight + 5}px`; // Set height based on scrollHeight
      // textareaRef.current.style.height = "100%";
      if (htmlRef.current.scrollHeight > 0) {
        onHeightChange(htmlRef.current.scrollHeight);
      }
    }
  };
  useEffect(() => {
    if (gridW) {
      adjustHTMLHeight();
    }
  }, [gridW, ckeditorData]);
  return (
    <>
      <div className="position-relative">
        <div style={combinedStyles}>
          <div ref={htmlRef} className="html-control" dangerouslySetInnerHTML={{ __html: ckeditorData || '' }} />
        </div>
        {fromForm && onElement && (
          <div className="potemp-action-btns">
            <button aria-label="Edit" type="button" className="btn btn-border ml-auto py-0 px-1" title="Add/Edit Content" onClick={() => setIsModalOpen(true)}>
              <EditIcon size={24} />
            </button>
            <button aria-label="Edit" type="button" className="btn btn-border ml-auto py-0 px-1" onClick={() => editingInput(gridIndex, pageIndex)}>
              <EditIcon size={24} />
            </button>
            <button aria-label="Copy" type="button" className="btn btn-border py-0 px-1" onClick={() => handleDuplicateItem()}>
              <DuplicateIcon size={24} />
            </button>
            <button
              aria-label="Active/Inactive Supplier"
              type="button"
              className={`btn btn-border py-0 px-1 ${supplierVisible ? 'text-success' : 'text-danger'}`}
              onClick={() => handleSupplierPermission(gridIndex, pageIndex)}
            >
              <ActiveIcon size={24} />
            </button>
            {showDelete && (
              <button aria-label="Delete" type="button" className="btn btn-border py-0 px-1" onClick={() => deleteItem(gridIndex, pageIndex)}>
                <DeleteIcon size={24} />
              </button>
            )}
            <button
              aria-label="Static"
              type="button"
              className={`btn btn-border py-0 px-1 ${isStatic && 'text-danger'}`}
              onClick={() => handleStaticGrid(gridIndex, pageIndex)}
            >
              <span className="icon-lock" />
            </button>
          </div>
        )}
      </div>
      {isModalOpen && (
        <HTMLCKeditor data={ckeditorData} show={isModalOpen} handleAddData={handleAddData} handleClose={handleClose} handleChange={handleCkeditor} />
      )}
    </>
  );
}
export default HTMLControl;
